import { createSelector } from '@reduxjs/toolkit';

import { isOrganization } from 'utils/Groups';

const selectGroups = (state: IAppState): IGroupInfo[] => state.groups.groupInfo.data;
const selectCurrentGid = (state: IAppState) => state.groups.selectedGid;

const getFirstGroup = (state: IAppState) =>
  state.groups.groupInfo.data.find((group) => group.gid !== 'all');

const getGroupByGid = (state: IAppState, gid: string) =>
  state.groups.groupInfo.data.find((group) => group.gid === gid);

const getGroupsState = (state: IAppState) => state.groups;

const getAllGroupsAndOrgsExcludingAll = createSelector([selectGroups], (groups) =>
  groups.filter((group) => group.gid !== 'all')
);

const getCurrentGroup = createSelector([selectGroups, selectCurrentGid], (groups, selectedGid) =>
  groups.find((group) => group.gid === selectedGid)
);

const getCurrentOrg = createSelector([selectGroups, getCurrentGroup], (groups, currentGroup) => {
  let org: IGroupInfo | undefined;
  if (currentGroup) {
    if (isOrganization(currentGroup)) {
      org = currentGroup;
    } else {
      org = groups.find((x) => x.gid === currentGroup.parentGid);
    }
  }
  return org;
});

const getCurrentOrgSubgroups = createSelector(
  [selectGroups, getCurrentOrg, getCurrentGroup],
  (groups, currentOrg, currentGroup) => {
    let subgroups: IGroupInfo[] = [];
    if (currentOrg && currentOrg.gid === 'all') {
      subgroups = groups.filter((group) => group.gid !== 'all' && group.gid !== group.parentGid);
    } else if (currentOrg) {
      subgroups = groups.filter(
        (group) => group.gid !== group.parentGid && group.parentGid === currentOrg.gid
      );
    } else if (currentGroup) {
      // If the user is a subgroups only user, we return the subgroups who share the same org as the currently selected group
      subgroups = groups.filter((group) => group.parentGid === currentGroup.parentGid);
    }

    return subgroups;
  }
);

export {
  selectGroups,
  selectCurrentGid,
  getFirstGroup,
  getGroupByGid,
  getGroupsState,
  getCurrentGroup,
  getCurrentOrg,
  getCurrentOrgSubgroups,
  getAllGroupsAndOrgsExcludingAll
};
